(() => {
  if (window.LegalFooterDirectoryInitialised) return;
  window.LegalFooterDirectoryInitialised = true;

  const mobile = window.matchMedia('(max-width: 749px)');

  const syncDirectory = () => {
    document.querySelectorAll('[data-legal-footer-directory]').forEach((directory) => {
      const mode = mobile.matches ? 'mobile' : 'desktop';
      if (directory.dataset.legalFooterMode === mode) return;

      const columns = [...directory.children]
        .map((column) => column.querySelector('details'))
        .filter(Boolean);
      columns.forEach((column, index) => { column.open = mode === 'desktop' || index === 0; });
      directory.dataset.legalFooterMode = mode;
    });
  };

  const syncCookiePreferences = () => {
    const showPreferences = window.privacyBanner?.showPreferences;
    document.querySelectorAll('[data-legal-cookie-preferences]').forEach((button) => {
      button.hidden = typeof showPreferences !== 'function';
      if (button.dataset.legalCookieBound === 'true') return;
      button.dataset.legalCookieBound = 'true';
      button.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
    });
  };

  const sync = () => {
    syncDirectory();
    syncCookiePreferences();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  window.addEventListener('load', syncCookiePreferences, { once: true });
  mobile.addEventListener('change', syncDirectory);
  document.addEventListener('shopify:section:load', sync);
})();
